import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyVehicleInformationAfterInquiryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVehicleInformationAfterInquiry/patchBodyVehicleInformationAfterInquiryFunction';
import { PatchBodyVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVehicleInformationAfterInquiry/patchBodyVehicleInformationAfterInquiry.type';

export const patchBodyVehicleInformationAfterInquiryOption =
  (): MutationOptions<
    AxiosResponse<any, any>,
    Error,
    PatchBodyVehicleInformationAfterInquiryType
  > => ({
    mutationKey: ['patch-body-information-after-inquiry'],
    mutationFn: ({ id, data }: PatchBodyVehicleInformationAfterInquiryType) =>
      patchBodyVehicleInformationAfterInquiryFunction({ id, data }),
  });
